import { Button, Tooltip } from '@mm/components';
import { useViewActions } from '@mm/state/actions/viewActions';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import React from 'react';
import styles from './LeadsContactsToolbarButtons.module.css';
import { useImportContactsPermission } from '../../../../../common/hooks/use-import-contacts-permission';
import { EnrichButton } from '../Contacts/EnrichButton/EnrichButton';
import { Help } from '../Integrations/NativeIntegrations/components/KlaviyoIntegrations/KlaviyoHelpLink';

interface P {
  processClick?: (callbackFb: (args?: any) => void) => void;
}

export const LeadsContactsToolbarButtons = (props: P) => {
  const { processClick = () => {} } = props;

  const uploadContactsPermission = useImportContactsPermission();
  const { openImportContactListModal } = useModalActions();
  const { showSlideoutMenu } = useViewActions();

  const onImportClick = () => openImportContactListModal();

  return (
    <>
      <Help
        link="https://customers.ai/help/l/en/article/atu9epbs2x-attribute-and-tags"
        text="Help Center"
      />

      <EnrichButton />

      <Tooltip
        title={
          !uploadContactsPermission.isAllowed ? (
            <div className={styles.tipBody}>
              'Connect an Email Account or activate a phone number first
            </div>
          ) : (
            ''
          )
        }
      >
        <Button
          css={{ container: styles.button }}
          disabled={!uploadContactsPermission.isAllowed}
          color="secondary"
          onClick={() => processClick(() => onImportClick())}
        >
          Import
        </Button>
      </Tooltip>

      <Button
        color="secondary"
        onClick={() => showSlideoutMenu('attributesAndTags')}
        css={{ container: styles.button }}
      >
        Attributes and Tags
      </Button>
    </>
  );
};
